import { PayloadAction } from '@reduxjs/toolkit';
import { IMenu } from '../../dashboard/components/left-menu/IMenu';

export const LeftMenuReducer = {
	toggleMenu: (state: IMenu, action: PayloadAction<boolean>) => {
		state.isClose = action.payload;
	},
	setInitialMenu: (state: IMenu, action: PayloadAction<IMenu>) => {
		state.isClose = action.payload.isClose;
		state.name = action.payload.name;
		state.list = action.payload.list;
		state.rol = action.payload.rol;
	},
};
